import React from 'react';
import InternalModal from './InternalModal';

const BaseModal = InternalModal;
const CompactModal = props => <InternalModal {...props} isCompact />;

export { BaseModal as default, CompactModal };
